/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Excel files in GridCraft with a practical XLSX workflow. Check formulas, charts, macros and format limits before saving a workbook back to Excel.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用实际流程了解 GridCraft 的 Excel 兼容性：打开 XLSX、检查公式和图表、另存副本，并核对宏与其他格式的限制。`)
};

/**
* | output |
* | --- |
* | "Use Excel files in GridCraft with a practical XLSX workflow. Check formulas, charts, macros and format limits before saving a workbook back to Excel." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_description = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_description(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_description(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_description as "gc.search_guides.gridcraft_excel_compatibility.description" }